var InvoiceElements = {
    refInvoiceId: "",
    refInvoiceNumber: "",
    clientAddress: {
        active: false,
        billTo: {
            address: String(""),
            state: String(""),
            pincode: 0,
            city: String("")
        },

        shipTo: {
            address: String(""),
            state: String(""),
            pincode: 0,
            city: String("")
        },
    },
    bankDetails: {
        active: false,
    },

    supplier: {
        name: String(""),  // required
        phone: 0,
        email: String(""),
        address: String(""),
        pincode: 0,
        state: String(""),
        city: String(""),
        photo: String(""),
        bankDetails: {
            active: false,
            accountNumber: 0,
            ifscCode: 0,
            bankName: String(""),
            branch: String(""),
            accountHolderName: String(""),
        },
    },

    buyer: {
        active: false,
        photo: String(""),
        name: String(""),
        phone: 0,
        email: String(""),
        legalName: String(""),

        billTo: {
            address: String(""),
            state: String(""),
            pincode: 0,
            city: String("")
        },

        shipTo: {
            address: String(""),
            state: String(""),
            pincode: 0,
            city: String("")
        },

        gstIn: String(""),
        panNo: String(""),
        openingBalance: 0,
        partyType: String(""),
        partyCategory: String(""),
        creditPeriod: String(""),
        creditLimit: String(""),

        customFields: [{
            id: false,
            title: String(""),
            value: String(""),
        }],
    },

    invoiceNumber: String(""),
    invoiceDate: Date,
    paymentTerms: String(""),
    dueDate: Date,
    quotationDate: Date,
    quotationCode: 0,
    poDate: Date,
    poCode: 0,
    placeOfSupply: String(""),

    items: [
    // {
    //     id: false,
    //     image: String(""),
    //     editable: false,
    //     custom: false,
    //     itemName: String(""),
    //     itemType: 0, // 1 - Product, 2 - Service
    //     itemCode: String(""),
    //     description: String(""),
    //     hsnCode: String(""),
    //     sacCode: String(""),
    //     mrp: 0,
    //     qty: 0,
    //     barcode: null,
    //     units: [{ title: String("") }],
    //     multipleUnits: false,
    //     pricePerItem: 0,

    //     discount: {
    //         percentage: 0,
    //         amount: 0,
    //     },

    //     tax: {
    //         type: 0, // 1- IGST, 2- CGST SGST
    //         taxType: String(""),

    //         igst: {
    //             percentage: 0,
    //             amount: 0,
    //         },
        
    //         cgst: {
    //             percentage: 0,
    //             amount: 0,
    //         },
        
    //         sgst: {
    //             percentage: 0,
    //             amount: 0,
    //         },
    //     },

    //     amount: String(""),

    //     // additional fields for creating item ---

    //     customFields: [{
    //         id: false,
    //         title: String(""),
    //         value: String(""),
    //     }],

    //     stock:{
    //         openingStock: 0,
    //         stockDate: Date,
    //         lowStockWarning: false,
    //         lowStockQuantity: 0
    //     },

    //     salesPrice: {
    //         withTax: false,
    //         amount: 0,
    //     },

    //     purchasePrice: {
    //         withTax: false,
    //         amount: 0,
    //     },

    //     wholeSalePrice: {
    //         withTax: false,
    //         amount: 0,
    //         minQty: 0,
    //     },
        
    // }
],

    subTotal: {
        discount: 0,
        tax: 0,
        amount: 0,
    },

    notes: {
        active: false,
        text: String(""),
    },

    termsContitons: {
        active: false,
        text: String(""),
    },

    emailSubject: {
        active: false,
        text: String(""),
    },

    emailText: {
        active: false,
        text: String(""),
    },

    discount : {
        apply: false,
        percentage: 0,
        amount: 0,
    },

    additionalCharges: {
        apply: false,
        charges: [],
        totalSum: 0
    },

    additionalFields: {
        apply: false,
        fields: [],
    },

    taxableAmount: 0,

    taxType: 0, // 1- IGST, 2- CGST SGST
    isTaxTypeIgst: false,
    igstPercentage : '',
    cgstPercentage : '',
    sgstPercentage : '',
    igstAmount: 0,
    cgstAmount: 0,
    sgstAmount: 0,

    tcs: {
        apply: false,
        taxType: String(""),
        totalAmount: 0,
        taxableAmount: 0,
        displayType: 0, // 1 - total , 2 - taxable
    },

    tds: {
        apply: false,
        totalAmount: 0,
        taxableAmount: 0,
        displayType: 0, // 1 - total , 2 - taxable
    },

    roundOff: {
        apply: false,
        type: String(""),
        amount: 0,
    },

    totalAmount: 0,
    totalPayableAmount: 0,
    finalAmount: 0,
    fullyPaid: false,
    receivedAmount: 0,
    instrumentId: String(""),
    paymentMode: String(""),
    balanceAmt: null,
    signature: String(""),
    journalEntry: String(""),
}
export default InvoiceElements;